var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Question"},[_c('div',{staticClass:"question",style:({ color: _vm.theme.primaryColor })},[_vm._v("\n        "+_vm._s(_vm.$t(("currentGame.Question." + _vm.currentTestName), {
                pronoun: _vm.$t(("currentGame.Question." + (_vm.question.gender)))
            }))+"\n    ")]),_c('FaceCardForTest',{attrs:{"question-index":_vm.itemIndex}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }